<script setup>
import { useRouter } from 'vue-router';
import upperArrow from '/src/image/home/home-bg/upperArrow.png'
import colorCircle from '/src/image/home/home-bg/colorCircle.png'
import playBtnIcon from '/src/image/common/playBtnIcon.png'
import item1 from '/src/image/home/item1.png'
import colorEdge from '/src/image/home/home-bg/colorEdge.png'
import texture1 from '/src/image/home/home-bg/texture1.png'
import woman from '/src/image//home/woman.png'
import texture4 from '/src/image/home//home-bg/texture4.png'
import texture2 from '/src/image/home/home-bg/texture2.png'
import product1 from '/src/image/home/home-bg/product1.png'
import product2 from '/src/image/home/home-bg/product2.png'
import product3 from '/src/image/home/home-bg/product3.png'
import product4 from '/src/image/home/home-bg/product4.png'
import texture3 from '/src/image/home/home-bg/texture3.png'
import colorEdge1 from '/src/image/home/home-bg/colorEdge1.png'
import CASE1 from '/src/image/home/home-bg/case1.png'
import CASE2 from '/src/image/home/home-bg/case2.png'
import CASE3 from '/src/image/home/home-bg/case3.png'
const router = useRouter()
const textureArr = [
	{
		bgUrl: '/src/image/home/home-bg/colorEdge2.png',
		style: 'top:1730px;right:0;height:448px',
	}
]

const jumptoPage = (url) => {
	router.push(url)
}

</script>

<template>
	<div class="home__wrapper">
		<div class="item">
			<img class="texture" :src="upperArrow"
				style="width:40px;height:99px;top: 0;left: -100px;" />
			<img class="texture" :src="colorCircle"
				style="width:176px;height:176px;top: -60px;left: 790px;" />
			<div class="description">
<!--				<div class="sub_title">TONGXUNXUNZENGZHIFUWU</div>-->
				<div class="title">关于我们</div>
				<div class="detail">
					旨在满足企业客户在营销、生产、协同场景中对于通讯能力的需求，通过帮助企业提高营销能力、业务效率和沟通体验以创造更大的商业价值。
				</div>
<!--				<div class="btns__wrapper">-->
<!--					<div class="btn">-->
<!--						视频介绍-->
<!--						<div class="icon">-->
<!--							<el-image style="width: 14px; height: 10px;" :src="playBtnIcon"-->
<!--								fit="contain" />-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
			</div>
			<div class="image">
				<el-image class="img" :src="item1" fit="cover" />
			</div>
		</div>

		<img class="texture" :src="colorEdge"
			style="height:448px;top:0;right: 0;z-index: -2;" />

		<div class="item_vertical">
			<img class="texture" :src="upperArrow"
				style="width:40px;height:99px;top:10px;right: 60px;" />
			<img class="texture" :src="texture1"
				style="width:366px;height:111px;top:10px;right: 200px;" />
			<div class="header">
<!--				<div class="sub_title">TONGXUNXUNZENGZHIFUWU</div>-->
				<div class="title">为什么选择我们</div>
			</div>
			<div class="description">
				<img :src="woman">
				<div class="detail">
					<p>
						致力于打造通信行业最全、最精、最专业的增值性服务！
					</p>
					<p>
						我们坚持以客户为中心，快速响应客户需求，持续为客户创造长期价值进而成就客户。
					</p>
					<p>为客户提供有效服务，是我们工作的方向和价值评价的标尺。</p>
					<p>成就客户就是成就我们自己！</p>
					<img class="texture" :src="texture4"
						style="width: 80px;height: 80px;left: -5px;bottom:-140px;z-index: -2;">
				</div>
			</div>
		</div>

		<img class="texture" :src="texture2"
			style="top:840px;right:0;width:110px;height:180px;z-index: -2;" />

		<div class="item_vertical">
			<div class="header" style="margin-bottom: 40px;">
<!--				<div class="sub_title">TONGXUNXUNZENGZHIFUWU</div>-->
				<div class="title">产品介绍</div>
			</div>
			<div class="description product_list">
				<div class="product_card" @click="jumptoPage('/numverify')" >
					<div class="text">号码认证</div>
					<el-image :src="product1" class="image-hover" fit="cover"/>
				</div>
				<div class="product_card" @click="jumptoPage('/flashLetter')">
					<div class="text">来电名片</div>
					<el-image :src="product2" class="image-hover" fit="cover"/>
				</div>
				<div class="product_card" @click="jumptoPage('/smsverify')">
					<div class="text">logo短信</div>
					<el-image :src="product3" class="image-hover" fit="cover"/>
				</div>
				<div class="product_card" @click="jumptoPage('/messagesend')">
					<div class="text">106短信</div>
					<el-image :src="product4" class="image-hover" fit="cover"/>
				</div>
			</div>
			<img class="texture" :src="texture3"
				style="top:125px;right:-57px;width:57px;height:356px;" />
		</div>

		<img class="texture" :src="colorEdge1"
			style="top:1390px;right:0;height:448px;z-index: -2;" />

		<div class="item_vertical">
			<div class="header" style="margin-bottom: 52px;">
<!--				<div class="sub_title">TONGXUNXUNZENGZHIFUWU</div>-->
				<div class="title">合作案例</div>
			</div>
			<div class="description">
				<div class="news_card">
					<el-image class="image" :src="CASE1" alt="" fit="cover" />
					<div class="text">
						<div>
							号码认证，提升品牌形象，避免误挂<br/>
							助力企业轻松提升2倍成单率
						</div>
<!--						<div class="time">-->
<!--							2019.08.05-->
<!--						</div>-->
					</div>
				</div>
				<div class="news_card">
					<el-image class="image" :src="CASE2" alt="" fit="cover" />
					<div class="text">
						<div>
							号码认证，提升品牌形象，避免误挂<br/>
							助力企业轻松提升2倍成单率
						</div>
<!--						<div class="time">-->
<!--							2019.08.05-->
<!--						</div>-->
					</div>
				</div>
				<div class="news_card">
					<el-image class="image" :src="CASE3" alt="" fit="cover" />
					<div class="text">
						<div>
							号码认证，提升品牌形象，避免误挂<br/>
							助力企业轻松提升2倍成单率
						</div>
<!--						<div class="time">-->
<!--							2019.08.05-->
<!--						</div>-->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
$itemMaxWidth: 1000px;

.texture {
	position: absolute;
	z-index: -1;
}

.home__wrapper {
	position: relative;
	margin-bottom: 104px;

	.item {
		position: relative;
		display: flex;
		width: 80%;
		max-width: $itemMaxWidth;
		min-height: 300px;
		margin: 96px auto 19px auto;

		.description {
			flex: 3;

			.sub_title {
				font-family: PingFang SC;
				font-size: 12px;
				font-weight: 400;
				line-height: 16.8px;
				text-align: left;
			}

			.title {
				font-family: PingFang SC;
				font-size: 44px;
				font-weight: 900;
				line-height: 64px;
				text-align: left;
				margin: 20px 0 24px 0;
				color: #002940;
			}

			.detail {
				font-family: PingFang SC;
				font-size: 18px;
				font-weight: 400;
				line-height: 31.8px;
				text-align: left;
				//color: #5e6282;
			}

			.btns__wrapper {
				margin-top: 56px;

				.btn {
					width: 100px;
					height: 40px;
					padding: 4px 4px 4px 16px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: #002751;
					border-radius: 49px;
					font-family: PingFang SC;
					font-size: 12px;
					font-weight: 600;
					line-height: 40px;
					text-align: center;
					color: #ffffff;

					.icon {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 32px;
						height: 32px;
						background-color: #ffffff;
						border-radius: 50%;
					}
				}
			}
		}

		.image {
			flex: 2;
			display: flex;
			justify-content: center;

			.img {
				width: 280px;
				height: 280px;
				border-radius: 24px;
			}
		}
	}

	.item_vertical {
		width: 80%;
		max-width: $itemMaxWidth;
		min-height: 300px;
		margin: 96px auto 19px auto;
		position: relative;

		.header {
			.sub_title {
				font-family: PingFang SC;
				font-size: 12px;
				font-weight: 400;
				line-height: 16.8px;
				text-align: left;
			}

			.title {
				font-family: PingFang SC;
				font-size: 44px;
				font-weight: 900;
				line-height: 64px;
				text-align: left;
				margin: 20px 0 24px 0;
				color: #002940;
			}
		}

		.description {
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			background-color: transparent;

			img {
				width: 344px;
				height: 362px;
				margin-right: 96px;
			}

			.detail {
				position: relative;
				width: 360px;
				height: 287px;
				font-family: PingFang SC;
				font-size: 18px;
				font-weight: 400;
				line-height: 31.8px;
				text-align: justified;
				//color: #5E6282;
				margin: 0 80px 0 auto;

				p {
					//margin: 20px 0;
				}
			}

			.product_card {
				position: relative;
				flex: 1 1 184px;
				// height: 356px;
				border-radius: 12px;
				margin: 0;
				cursor: pointer;

				.text {
					width: 100%;
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
					top: 28px;
					z-index: 1;
					color: #fff;
					font-family: PingFang SC;
					font-size: 20px;
					font-weight: 400;
					line-height: 28px;
					text-align: center;
				}

				.image-hover:hover {
					border: 5px solid rgba(255, 255, 255, 0.5);
				}

				&:first-child {
					margin-left: 0;
				}
			}

			.news_card {
				flex: 1;
				margin-bottom: 50px;
				border-radius: 12px;
				overflow: hidden;
				background: #ffffff;
				box-shadow: 0px 12px 12px 0px #0000000a;
				margin-left: 24px;
				&:first-child {
					margin-left: 0;
				}

				.image {
					width: 269px;
				}

				.text {
					padding: 24px;
					font-size: 14px;
					font-weight: 700;
					line-height: 25px;
					color: #002940;
					font-family: PingFang SC;

					.time {
						margin-top: 24px;
						font-size: 12px;
						font-weight: 400;
						line-height: 16.8px;
						color: #002940;
					}
				}
			}
		}

		.product_list {
			// gap: 21px;
			.product_card {
				margin-left: 21px;
				&:first-child {
					margin-left: 0;
				}
			}
		}
	}
}
</style>
